import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import Header from "../layouts/Headerfour";
import Breadcrumb from "../layouts/Userbreadcrumb";
import Footer from "../layouts/Footer";
import Content from "../sections/profile-saved-listings/Content";

class Profilesavedlistings extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
        <title>Buy Home For Less | My Products</title>
        <meta name="description" content="#" />
      </Helmet>
        <Header />
        <Breadcrumb />
        <Content />
        <Footer />
      </Fragment>
    );
  }
}

export default Profilesavedlistings;
